import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';

@Component({
  selector: 'app-supply-chain-ontime-delivery-calculator',
  templateUrl: './supply-chain-ontime-delivery-calculator.component.html',
  styleUrls: ['./supply-chain-ontime-delivery-calculator.component.css']
})
export class SupplyChainOntimeDeliveryCalculatorComponent implements OnInit {

  form;
  ngOnInit () {

    this.form = new FormGroup ( {

    value1: new FormControl(''),
    value2: new FormControl(''),
    } )

  } 
  ontimeDeli(n1,n2){
    var ontimeDel=(n1)/n2;
    var ontimeDelsimple= ontimeDel.toFixed(2);
    return ontimeDelsimple ;
    }

}



// WEBPACK FOOTER //
// C:/my-dream-app/src/app/supply-chain-ontime-delivery-calculator/supply-chain-ontime-delivery-calculator.component.ts